'use client';

import styled, { css } from 'styled-components';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 16px;

  @media (max-width: ${breakpoints.mobile}) {
    gap: 8px;
  }
`;

export const Search = styled.form`
  display: flex;

  padding: 16px;
  gap: 16px;

  background-color: ${colors.gray1};
  border: 1px solid ${colors.gray3};
  border-radius: 16px;

  &:hover {
    cursor: pointer;
    border: 1px solid ${colors.gray4};
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 8px;
    gap: 8px;
  }
`;

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  color: ${colors.gray4};

  ${({ $bordered }) =>
    $bordered &&
    css`
      border-left: 1px solid ${colors.gray3};

      &:hover {
        cursor: pointer;
        background-color: ${colors.gray2};
      }
    `};
`;

export const Input = styled.input`
  width: 100%;

  border: 1px solid transparent;
  background-color: transparent;

  &:focus {
    outline: none;
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.9rem;
  }
`;

export const ActiveFilters = styled.div`
  display: flex;
  flex-wrap: wrap;

  gap: 8px;
`;

export const FilterBadge = styled.div`
  display: flex;
  align-items: center;

  color: ${colors.gray5};
  border: 1px solid ${colors.gray3};
  border-radius: 8px;
  overflow: hidden;

  & > span {
    display: flex;
    align-items: center;

    padding: 8px 12px;

    font-size: 0.9rem;
    font-weight: 500;
  }

  ${({ $addFilter }) =>
    $addFilter &&
    css`
      border: 1px dashed ${colors.gray3};

      & > span {
        padding-left: 0;
      }

      &:hover {
        cursor: pointer;
        border: 1px dashed ${colors.gray4};
      }
    `};

  @media (max-width: ${breakpoints.mobile}) {
    & > span {
      padding: 6px 8px;

      font-size: 0.8rem;
    }
  }
`;

export const MenuWrap = styled.div`
  position: relative;
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;

  position: absolute;
  top: 40px;
  left: 0;

  width: 370px;
  padding: 16px;
  gap: 16px;

  border-radius: 12px;
  background-color: ${colors.light};
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;

  z-index: 9;

  @media (max-width: ${breakpoints.smallMobile}) {
    font-size: 0.8rem;
    width: 300px;
  }
`;
